import PropTypes from "prop-types";
import { useMemo, useCallback } from "react";
import { useQueryClient } from "react-query";

import renderCreditBuilderOptIn from "../Modals/Credit-Builder/credit-builder-opt-in";
import renderCreditBuilderTracker from "../Modals/Credit-Builder/credit-builder-tracker";

import { useModalContext } from "../../Contexts/ModalContext";

import { useRentDetails, useCreditReportDetails } from "../../CustomHooks/Queries";

import { APIQueryKeys } from "../../Utils/constants";

import "./home-card.scss";

const HomeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M3 15V7l6-5 6 5v8a1 1 0 01-1 1H4a1 1 0 01-1-1z"
      stroke="var(--accent)"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path d="M7 15v-5h4v5" stroke="var(--accent)" strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

export default function HomeCard({ creditReporting }) {
  const modalContext = useModalContext();
  const queryClient = useQueryClient();

  const { data: rentDetails } = useRentDetails();

  const address = useMemo(() => {
    const user = rentDetails?.data?.data?.my_home_rent;
    if (!user || !user?.address1) return "";
    return user?.address2 ? `${user.address1} ${user.address2}` : user.address1;
  }, [rentDetails?.data?.data?.my_home_rent]);

  const isCreditBuilderActive = useMemo(() => {
    return creditReporting?.data?.data?.credit_builder?.opted_in ?? false;
  }, [creditReporting?.data?.data?.credit_builder?.opted_in]);

  const isCreditBuilderEligible = useMemo(() => {
    return creditReporting?.data?.data?.credit_builder?.is_eligible ?? false;
  }, [creditReporting?.data?.data?.credit_builder?.is_eligible]);

  const handleCreditBuilderClick = useCallback(() => {
    if (isCreditBuilderActive) {
      renderCreditBuilderTracker(modalContext);
    } else {
      renderCreditBuilderOptIn(modalContext, {
        onOptIn: () => queryClient.refetchQueries(APIQueryKeys.creditReporting),
      });
    }
  }, [isCreditBuilderActive, modalContext, queryClient]);

  return (
    <div className="home-card">
      <div className="hc-header">
        <div className="hc-icon">
          <HomeIcon />
        </div>
        <div className="hc-info">
          <span className="hc-title">{address || "My Home"}</span>
        </div>
      </div>
      {isCreditBuilderEligible && (
        <div className="hc-row" onClick={handleCreditBuilderClick}>
          <div className="hc-row-left">
            <span className="hc-label">Credit Builder</span>
            <span className={`hc-badge ${isCreditBuilderActive ? "active" : "inactive"}`}>
              {isCreditBuilderActive ? "Active" : "Inactive"}
            </span>
          </div>
          <svg className="hc-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4l4 4-4 4" stroke="#8B8FA3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}
    </div>
  );
}

HomeCard.propTypes = {
  creditReporting: PropTypes.object,
};
